<div class="page-header-container">
  <div class="page-header-content">
    <div class="page-header-left-column">
      <md-page-header title="{{ pageTitle() }}" icon="partner"></md-page-header>
      <md-pricing-entity-shortcuts [entityId]="byproductId()" entityType="byproducts" (addPrice)="showAddPriceDialog()"> </md-pricing-entity-shortcuts>
    </div>
    <div class="page-header-right-column-wrapper">
      <mat-form-field class="page-header-right-column no-subscript">
        <mat-label>{{ 'SEARCH.PRICES' | translate }}</mat-label>
        <input matInput type="text" [formControl]="searchInput" />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
      <div class="page-header-right-column">
        <md-pricing-bulk-operations-form [selectedPrices]="selectedPrices()" [isLoading]="isLoading()" (updateRequest)="handleBulkPriceUpdate($event)">
        </md-pricing-bulk-operations-form>
      </div>
    </div>
  </div>
</div>

<div class="grid-container">
  <div class="grid-header-container">
    <div class="grid-header-actions">
      <button mat-flat-button color="primary" (click)="exportToExcel()" [disabled]="isExporting()">
        <mat-icon>file_download</mat-icon>
        {{ 'COMMON.EXPORT_EXCEL' | translate }}
      </button>
    </div>
  </div>

  <ag-grid-angular
    domLayout="autoHeight"
    [pagination]="true"
    [theme]="theme"
    [rowData]="displayPrices()"
    [columnDefs]="columnDefs()"
    [rowSelection]="rowSelection"
    (rowClicked)="onRowClicked($event)"
    (selectionChanged)="onSelectionChanged($event)"
  ></ag-grid-angular>
</div>
